export const translation = {
  translatedCouponNotThere: Drupal.t('A code must be entered.'),
  total: Drupal.t('Total'),
  order: Drupal.t('Order'),
  orderDate: Drupal.t('Order date'),
  cinema: Drupal.t('Cinema'),
  pass: Drupal.t('Pass'),
  startTime: Drupal.t('Start time'),
  orderSummarySuccessHeading: Drupal.t('Thank you for your order!'),
  orderSummaryErrorHeading: Drupal.t('Your order could not be completed!'),
  orderSummaryErrorDescription: Drupal.t('If your payment has been debited and you still see this message, please contact events@aktiongegendenhunger.de immediately.\n' +
    'Thank you for your understanding!'),
  close: Drupal.t('Close'),
  cancel: Drupal.t('Cancel'),
  receipt: Drupal.t('Receipt'),
  tickets: Drupal.t('Tickets'),
  ticketOverview: Drupal.t('Ticket overview'),
  coupon: Drupal.t('Coupon'),
  notice: Drupal.t('Notice'),
  order_tickets_success: Drupal.t('Check your email—a printable copy of these tickets is waiting for you. You can access your tickets at any time in the web interface simply by clicking "My Tickets" in the upper righthand corner. Just visit this site on your phone at the venue and present your tickets electronically!'),
}